import axios from 'axios';
import { toast } from 'react-toastify';

// Create axios instance for admin portal
const adminApi = axios.create({
  baseURL: process.env.REACT_APP_ADMIN_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
adminApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle other errors
    if (error.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error.message) {
      toast.error(error.message);
    }
    // Handle 401 Unauthorized errors
    else if (error.response?.status === 401) {
      // Clear storage
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      
      // Show error toast
      toast.error('Session expired. Please login again.');
      
      // Redirect to login page if not already there
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/hpanel/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default adminApi;